import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root'
})
export class ContactService {

  constructor(private httpClient: HttpClient, private apiService: ApiService) { }

  public password(current_password: string | null, new_password: string | null): Observable<any> {
    return this.httpClient.post(`${this.apiService.apiUrl()}/api/customer/contact/password`, { current_password: current_password, new_password: new_password });
  }

  public setPassword(password: string | null): Observable<any> {
    return this.httpClient.post(`${this.apiService.apiUrl()}/api/customer/contact/set-password`, { password: password });
  }

}
